import { sizeVariants } from "../../variants/interactions/iconography.variants.js";
import { tv } from "../../variants/tv.js";
const iconToggleButtonEmphasisVariants = {
    regular: {},
    bold: {}
};
const iconToggleButtonEmphases = Object.keys(iconToggleButtonEmphasisVariants);
const iconToggleButtonVariants = tv({
    slots: {
        buttonSlot: 'cursor-pointer',
        iconBorderSlot: 'transition-colors',
        iconFillSlot: 'fill-transparent stroke-0 transition-colors'
    },
    variants: {
        size: sizeVariants,
        isToggledOn: {
            true: {
                iconFillSlot: 'fill-current'
            },
            false: {}
        },
        emphasis: {
            regular: {
                iconBorderSlot: 'fill-current'
            },
            bold: {
                iconBorderSlot: 'fill-actionPrimary-1 drop-shadow-md'
            }
        },
        disabled: {
            true: {
                buttonSlot: 'cursor-not-allowed'
            },
            false: {}
        },
        palette: {
            primary: {
                buttonSlot: 'text-actionPrimary-8 hover:text-actionPrimary-9'
            },
            favorite: {
                buttonSlot: 'text-favorite-8 hover:text-favorite-9'
            }
        }
    },
    compoundVariants: [
        {
            emphasis: 'bold',
            isToggledOn: false,
            class: {
                iconFillSlot: 'hover:fill-actionPrimary-13/40'
            }
        }
    ],
    defaultVariants: {
        size: '32',
        emphasis: 'regular',
        isToggledOn: false,
        disabled: false,
        palette: 'primary'
    }
});
export { iconToggleButtonEmphases, iconToggleButtonEmphasisVariants, iconToggleButtonVariants };
